import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { Users, Tags, Building2, Scale, ListTree, Target, ShieldAlert, Workflow } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';

const cadastroLinks = [
  { title: 'Pessoas', desc: 'Gerenciar pessoas físicas e jurídicas', icon: Users, path: '/system/cadastros/pessoas', color: 'text-blue-500', bg: 'bg-blue-50' },
  { title: 'Tipos de Pessoa', desc: 'Classificações de pessoas', icon: Tags, path: '/system/cadastros/tipo-pessoa', color: 'text-indigo-500', bg: 'bg-indigo-50' },
  { title: 'Palavras-Chave', desc: 'Termos e tags do sistema', icon: ListTree, path: '/system/cadastros/palavra-chave', color: 'text-teal-500', bg: 'bg-teal-50' },
  { title: 'Comarcas e Varas', desc: 'Locais e instâncias jurídicas', icon: Building2, path: '/system/cadastros/comarca-vara', color: 'text-cyan-500', bg: 'bg-cyan-50' },
  { title: 'Situações de Processo', desc: 'Status atual do processo', icon: Workflow, path: '/system/cadastros/situacao-processo', color: 'text-amber-500', bg: 'bg-amber-50' },
  { title: 'Naturezas de Processo', desc: 'Categorização jurídica', icon: Scale, path: '/system/cadastros/natureza-processo', color: 'text-orange-500', bg: 'bg-orange-50' },
  { title: 'Ações e Objetos', desc: 'Objetos da ação processual', icon: Target, path: '/system/cadastros/acao-objeto', color: 'text-red-500', bg: 'bg-red-50' },
  { title: 'Status Impugnação', desc: 'Fases de impugnação', icon: ShieldAlert, path: '/system/cadastros/status-impugnacao', color: 'text-rose-500', bg: 'bg-rose-50' },
];

export default function CadastrosSystemPage() {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto py-12 px-4 max-w-7xl">
      <Helmet>
        <title>Central de Cadastros - Sistema</title>
        <meta name="description" content="Central de gerenciamento de cadastros auxiliares do sistema." />
      </Helmet>

      <div className="mb-8">
        <h1 className="text-3xl font-bold text-[#193D6D]">Central de Cadastros</h1>
        <p className="text-gray-500 mt-2">Gerencie todas as tabelas auxiliares e de referência do sistema.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cadastroLinks.map((item, index) => (
          <Card 
            key={index} 
            className="hover:shadow-md transition-all duration-300 cursor-pointer border border-gray-100 hover:border-gray-200"
            onClick={() => navigate(item.path)}
          >
            <CardHeader className="pb-3">
              <div className={`w-12 h-12 rounded-xl ${item.bg} flex items-center justify-center mb-4`}>
                <item.icon className={`w-6 h-6 ${item.color}`} />
              </div>
              <CardTitle className="text-lg text-gray-800">{item.title}</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm text-gray-500">
                {item.desc}
              </CardDescription>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}